import {
  getEmojiFromDashboard,
  trackDashboardEvent,
} from '@modules/dashboard/helpers';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { DashboardListItem } from 'generated/graphql';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getDashboardRoute } from 'v2/core/services/dashboard/link';
import { useGetUser } from 'v2/core/services/user';
import { PinDashboardIcon } from '../PinDashboardIcon';

interface DashboardNavigationListItemProps {
  dashboard: DashboardListItem;
  onClose: () => void;
}

export const DashboardNavigationListItem = ({
  dashboard,
  onClose,
}: DashboardNavigationListItemProps) => {
  const theme = useTheme();

  const { id: userID } = useGetUser();
  const [isHovering, setIsHovering] = useState(false);

  const dashboardLink = getDashboardRoute({
    name: dashboard.title,
    token: dashboard.viewToken,
  });

  const dashboardEmoji = getEmojiFromDashboard(dashboard);
  const dashboardName = dashboard.title;

  const onPinChange = (isPinned: boolean) => {
    trackDashboardEvent({
      eventName: isPinned ? 'Dashboard Pinned' : 'Dashboard Unpinned',
      dashboardLink,
      from: 'Sidebar',
    });
  };

  const createdByUserName =
    dashboard.createdBy.id === userID
      ? ''
      : `${dashboard.createdBy.firstName} ${dashboard.createdBy.lastName}` ??
        '';

  return (
    <ListItem
      disablePadding
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      secondaryAction={
        <Box
          sx={{
            visibility: isHovering ? 'visible' : 'hidden',
          }}
        >
          <PinDashboardIcon
            dashboardID={dashboard.id}
            iconColor={theme.palette.text.primary}
            iconEdge="end"
            onChange={onPinChange}
          />
        </Box>
      }
    >
      <ListItemButton
        component={Link}
        to={dashboardLink}
        onClick={onClose}
        title={dashboardName}
        sx={{
          width: '100%',
          alignItems: 'baseline',
        }}
      >
        <ListItemIcon sx={{ minWidth: '36px', color: 'unset' }}>
          {dashboardEmoji}
        </ListItemIcon>
        <ListItemText primary={dashboardName} secondary={createdByUserName} />
      </ListItemButton>
    </ListItem>
  );
};
